<template>
  <div
    class="homework-list-content-item"
    v-show="isCurrentContentItem"
    v-bitmap="getHomeworkListResult"
  >
    <div class="homework-list-content-main">
      <homeworkItem
        v-for="(item, index) in homeworkList"
        :key="item.id"
        :homeworkInfo="item"
        class="homework-item"
        :style="{ 'animation-duration': `${(index + 1) * 0.3}s` }"
      />
    </div>
    <pagination
      :pageSize="pageSize"
      :total="homeworkTotal"
      @currentPageNumChange="currentPageNumChange"
      @handleSizeChange="handleSizeChange"
    ></pagination>
  </div>
</template>

<script>
import homeworkItem from "@/components/homework-item/homeworkItem";
export default {
  data() {
    return {
      homeworkTotal: 0,
      pageSize: 10,
      pageNum: 1,
      homeworkList: null,
      getHomeworkListResult: "nullData",
    };
  },
  components: {
    homeworkItem,
  },
  props: {
    courseInfo: {
      type: Object,
    },
    isCurrentContentItem: {
      type: Boolean,
    },
    currentDate: {
      type: String,
    },
    homeworkKeyWord: {
      type: String,
    },
    classData: {
      type: Object,
    },
    classId: {
      type: String,
    },
    semester: {
      type: [String, Number],
    },
    schoolYear: {
      type: [String, Number],
    },
  },
  watch: {
    isCurrentContentItem: {
      handler(val) {
        if (val && !this.homeworkList) {
          this.getHomeworkList();
        }
      },
      immediate: true,
    },
    currentDate(val) {
      if (this.isCurrentContentItem) {
        this.getHomeworkList();
      }
    },
    homeworkKeyWord() {
      if (this.isCurrentContentItem) {
        this.getHomeworkList();
      }
    },
    classId() {
      if (this.isCurrentContentItem) {
        this.getHomeworkList();
      }
    },
    semester() {
      if (this.isCurrentContentItem) {
        this.getHomeworkList();
      }
    },
    schoolYear() {
      if (this.isCurrentContentItem) {
        this.getHomeworkList();
      }
    },
  },
  methods: {
    getHomeworkList() {
      // this.getHomeworkListResult = "loading";
      this.get(this.$url.selectTeacherHomeworkList, {
        classId: this.classData.classId,
        publicTime: this.currentDate,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        courseName: this.courseInfo.courseName,
        title: this.homeworkKeyWord,
        semester: this.semester,
        schoolYear: this.schoolYear,
      })
        .then((res) => {
          // console.log("获取作业列表==>", res);
          if (res.code != 200) {
            this.$message.error(res.msg);
            return (this.getHomeworkListResult = "error");
          }
          res.msg !== "查询成功,暂未查到相关数据"
            ? (this.getHomeworkListResult = "success")
            : (this.getHomeworkListResult = "nullData");
          this.homeworkTotal = res.total;
          this.homeworkList = res.rows;
        })
        .catch((err) => {
          console.log("获取作业列表报错==>", err);
          // this.$message.error("获取作业列表失败");
          // this.getHomeworkListResult = "error";
        });
    },
    currentPageNumChange(e) {
      this.pageNum = e;
      this.getHomeworkList();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getHomeworkList();
    },
  },
};
</script>

<style lang="sass" scoped>
@import "./homeworkListContentItem.scss"
</style>
